define.alias("shared/components/shared/social/connect-profile", "settings/components/shared/social/connect-profile");